<ng-container *ngIf="isCreateMode() || isUpdateMode()">
  <form (ngSubmit)="save()" [formGroup]="form">
    <base-form-header
      [mode]="mode"
      createLabel="Nouvelle affectation"
      updateLabel="Modifier l'affectation"
    ></base-form-header>

    <mat-dialog-content fxLayout="column">
      <base-form-input
        label="Etablissement"
        controlName="establishment"
        type="autocomplete"
        [items$]="establishments$"
        (autocompleteChange)="establishmentChange($event)"
        displayProperty="label"
        [autoSelectExactMatch]="true"
      ></base-form-input>

      <div *ngIf="establishmentSearchMessage" class="my-2 text-hint">{{ establishmentSearchMessage }}</div>

      <ng-container *ngIf="form.controls.establishment.value?._id">
        <div *ngIf="activitiesLoading" class="my-2">
          <mat-spinner diameter="20"></mat-spinner>
        </div>
        <ng-container *ngIf="!activitiesLoading">
          <div *ngIf="noActivitiesConfigured" class="my-2 text-hint">
            Aucune activité configurée sur cet établissement.
          </div>
          <div *ngIf="activities.length > 0" class="mt-2">
            <label class="text-xs text-hint">Activités</label>
            <div class="flex flex-col gap-1 mt-1">
              <mat-checkbox
                [checked]="areAllActivitiesSelected()"
                [indeterminate]="areSomeActivitiesSelected()"
                (change)="onToggleAll($event.checked)"
              >
                Tout sélectionner
              </mat-checkbox>
              <mat-divider></mat-divider>
              <mat-checkbox
                *ngFor="let activity of activities"
                [checked]="isActivitySelected(activity)"
                (change)="onActivityToggle(activity, $event.checked)"
              >
                {{ activity.label }}
              </mat-checkbox>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <base-form-input
        type="submit"
        [mode]="mode"
        [loading]="loading"
        entityLabel="USER"
        (onCreate)="createItem()"
        (onUpdate)="updateItem()"
      ></base-form-input>
    </mat-dialog-actions>
  </form>
</ng-container>

<ng-container *ngIf="isDeleteMode()">
  <form-modal-delete-base
    [label]="data.name"
    [title]="title"
    (onClose)="close()"
    (onDelete)="deleteItem()"
    [loading]="loading"
    defaultMessage="Êtes-vous sûr de vouloir supprimer cette affectation ?"
  ></form-modal-delete-base>
</ng-container>
